import axios from 'axios'
import { REACT_APP_API_ABM } from '../../config'

const defaultData = { symbol: '$', actualSellValue: 1, defaultCurrency: null, multiplier: 1 }

export async function getCurrency(id, setCancelToken) {
  const headers = {}
  if (setCancelToken) {
    headers.cancelToken = new axios.CancelToken(setCancelToken)
  }

  const exchangeRates = await axios(
    `${REACT_APP_API_ABM}/abms/exchange-rates/${id}`,
    headers
  )
  const {
    data: { data }
  } = exchangeRates
  //en data me va a venir el defaultCurrency en true o false, si viene en true no multiplicar
  if (data) {
    const currency = await axios( `${REACT_APP_API_ABM}/abms/currencies/${data.currency_id}?manual=false`)
    const resp = currency?.data?.data
    if(resp) {
      //hacer un if que si el data.defaultCurrency es true multiplicar el data.multiplier * resp.actualSellValue y por los demas campos
      return { ...resp, multiplier: data.multiplier, defaultCurrency: data.defaultCurrency  }
    } 
    return defaultData
  }
  return defaultData
}
